import { GRNPaymentStatus } from 'src/models/enums/GRNStatus.enum';
import { userRoles } from './properties.utils';

export interface GRNPaymentPermissions {
  canView: boolean;
  canEdit: boolean;
  canApprove: boolean;
  canReject: boolean;
  canDelete: boolean;
}

export const getGRNPaymentPermissions = (
  userRole: string,
  status: GRNPaymentStatus
): GRNPaymentPermissions => {
  const normalizedRole = userRole?.toLowerCase()?.trim() || '';

  const isAdminOrOwner =
    normalizedRole === userRoles.ADMIN.toLowerCase() ||
    normalizedRole === userRoles.OWNER.toLowerCase();
  const isFactoryManagerOrExecutive =
    normalizedRole === userRoles.FACTORY_MANAGER.toLowerCase() ||
    normalizedRole === userRoles.EXECUTIVE.toLowerCase();

  const isPendingApproval = status === GRNPaymentStatus.PENDING_APPROVAL;

  // View is allowed for all roles
  const canView = true;

  // Edit is allowed for all roles when status is PENDING_APPROVAL
  const canEdit =
    (isAdminOrOwner || isFactoryManagerOrExecutive) && isPendingApproval;

  // Delete is allowed for all roles when status is PENDING_APPROVAL
  const canDelete =
    (isAdminOrOwner || isFactoryManagerOrExecutive) && isPendingApproval;

  // Approve and Reject are only allowed for Admin and Owner when status is PENDING_APPROVAL
  // Factory Manager and Executive should NOT have Approve and Reject options
  const canApprove = isAdminOrOwner && isPendingApproval;
  const canReject = isAdminOrOwner && isPendingApproval;

  const permissions: GRNPaymentPermissions = {
    canView,
    canEdit,
    canApprove,
    canReject,
    canDelete,
  };

  return permissions;
};
